var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVinyl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.009 32.009",
    style: {
      enableBackground: "new 0 0 32.009 32.009"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M21.951,1.151c-8.202-3.284-17.515,0.702-20.8,8.905c-3.286,8.204,0.702,17.518,8.905,20.802 c8.203,3.285,17.516-0.702,20.801-8.905C34.143,13.749,30.154,4.437,21.951,1.151z M10.8,29.002 c-7.166-2.87-10.662-11.034-7.793-18.201c2.87-7.166,11.035-10.663,18.202-7.792c7.166,2.869,10.662,11.034,7.793,18.2 C26.131,28.376,17.967,31.871,10.8,29.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M16.749,14.148c-1.025-0.411-2.19,0.088-2.601,1.113s0.088,2.189,1.112,2.6 c1.025,0.411,2.191-0.088,2.601-1.112C18.271,15.724,17.773,14.56,16.749,14.148z M15.632,16.934 c-0.512-0.206-0.761-0.788-0.557-1.301c0.206-0.512,0.789-0.761,1.301-0.557c0.511,0.205,0.76,0.788,0.556,1.301 C16.727,16.889,16.144,17.138,15.632,16.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M18.234,10.436c-3.076-1.232-6.568,0.264-7.8,3.339c-1.232,3.076,0.264,6.568,3.339,7.8 c3.076,1.232,6.568-0.263,7.8-3.339S21.311,11.667,18.234,10.436z M14.518,19.718c-2.048-0.819-3.046-3.153-2.227-5.2 c0.82-2.047,3.152-3.046,5.199-2.227c2.049,0.82,3.047,3.154,2.229,5.201C18.898,19.539,16.565,20.539,14.518,19.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M23.432,18.979c0.102-0.256-0.023-0.547-0.279-0.649c-0.256-0.104-0.547,0.021-0.65,0.278v-0.001 c-0.719,1.796-2.098,3.129-3.744,3.834c-0.252,0.108-0.371,0.402-0.262,0.655c0.109,0.255,0.402,0.372,0.656,0.264 c0.01-0.004,0.014-0.012,0.021-0.015c1.873-0.81,3.439-2.327,4.256-4.366H23.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M26.865,19.815c-0.256-0.103-0.547,0.022-0.65,0.278c-1.129,2.82-3.295,4.915-5.883,6.023 c-0.252,0.108-0.371,0.402-0.262,0.656c0.109,0.255,0.402,0.371,0.656,0.263c0.012-0.006,0.021-0.017,0.033-0.022 c2.809-1.213,5.16-3.49,6.385-6.548C27.246,20.209,27.121,19.918,26.865,19.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25.008,19.072c-0.256-0.103-0.547,0.021-0.65,0.278c-0.922,2.308-2.693,4.021-4.812,4.928h0.002 c-0.254,0.109-0.373,0.403-0.264,0.657s0.402,0.371,0.656,0.263c0.01-0.005,0.016-0.014,0.027-0.02 c2.34-1.011,4.299-2.907,5.32-5.456C25.389,19.466,25.264,19.175,25.008,19.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M13.513,8.913c-0.109-0.255-0.403-0.371-0.657-0.262c-0.009,0.003-0.014,0.011-0.021,0.014 c-1.873,0.81-3.44,2.328-4.256,4.366H8.578c-0.103,0.257,0.022,0.547,0.278,0.65c0.257,0.103,0.548-0.022,0.65-0.278h0.001 c0.718-1.794,2.097-3.128,3.743-3.832C13.504,9.461,13.622,9.168,13.513,8.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M11.938,5.236c-0.109-0.254-0.403-0.371-0.657-0.263c-0.012,0.005-0.021,0.016-0.031,0.021 c-2.81,1.214-5.16,3.49-6.385,6.548c-0.104,0.258,0.021,0.549,0.278,0.651c0.256,0.103,0.547-0.021,0.65-0.278 c1.13-2.819,3.295-4.914,5.883-6.022C11.929,5.783,12.047,5.49,11.938,5.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M12.463,7.73c0.253-0.108,0.372-0.401,0.263-0.656c-0.109-0.253-0.403-0.371-0.657-0.262 c-0.01,0.004-0.016,0.014-0.026,0.018c-2.341,1.012-4.3,2.91-5.32,5.458C6.619,12.545,6.745,12.835,7,12.939 c0.256,0.102,0.547-0.021,0.65-0.278c0.923-2.308,2.695-4.022,4.812-4.928V7.73H12.463z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinyl);
export default __webpack_public_path__ + "static/media/vinyl.ef8f1baf4d65c3388c9c9a5ba6504d40.svg";
export { ForwardRef as ReactComponent };